import { render } from "./market-select.vue?vue&type=template&id=5d188bd4&scoped=true"
import script from "./market-select.vue?vue&type=script&lang=js"
export * from "./market-select.vue?vue&type=script&lang=js"

import "./market-select.vue?vue&type=style&index=0&id=5d188bd4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d188bd4"]])

export default __exports__